import { MdDashboard } from "react-icons/md";
import { AiOutlineBranches, AiOutlineUser } from "react-icons/ai";
import { GrMoney, GrTest } from "react-icons/gr";
import { PiUserListBold } from "react-icons/pi";
import { BsClipboard2Check } from "react-icons/bs";
import { PiCertificate } from "react-icons/pi";
import { HiOutlineInboxArrowDown } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { FaBuildingUser } from "react-icons/fa6";
import { styled } from "styled-components";
import { FaRegCalendarAlt } from "react-icons/fa";
import { MenuProps } from "antd";
import {
  ProfileOutlined,
} from '@ant-design/icons';
type MenuItem = Required<MenuProps>["items"][number];

const CustomLink = styled(Link)`
  text-decoration: none;
`;

const items: MenuItem[] = [
  {
    key: "1",
    icon: <MdDashboard />,
    label: <CustomLink to="/dashboard">{"داشبورد"}</CustomLink>,
  },
  // {
  //   key: "2",
  //   icon: <FaRegIdBadge />,
  //   label:<CustomLink to="/legal-rules">{"نقش حقوقی"}</CustomLink>,
  // },

  {
    key: "3",
    icon: <PiCertificate />,
    label: (
      <CustomLink to="/labratory-accreditation-certificates">
        {"درخواست گواهینامه"}
      </CustomLink>
    ),
  },
  {
    key: "4",
    icon: <PiUserListBold />,
    label: <CustomLink to="/assessment-bank">{"بانک ارزیابان"}</CustomLink>,
  },
  {
    key: "5",
    icon: <BsClipboard2Check />,
    label: <CustomLink to="/assessment">{"ارزیابی"}</CustomLink>,
  },
  // {
  //   key: "6",
  //   icon: <LuCalendarCheck2 />,
  //   label: "تقویم",
  // },
  {
    key: "7",
    icon: <AiOutlineBranches />,
    label: <CustomLink to="/agent">مدیریت نمایندگان</CustomLink>,
  },
  // {
  //   key: "8",
  //   icon: <AiOutlineFileExclamation />,
  //   label: <CustomLink to="/assessment-bank">{"مدیریت تیکت ها"}</CustomLink>,
  // },
  // {
  //   key: "9",
  //   icon: <GrServices />,
  //   label: "مدیریت سیستم",
  // },
  {
    key: "10",
    icon: <GrMoney />,
    label: <CustomLink to="/paymet-list">{"مدیریت پرداخت ها"}</CustomLink>,
  },
  {
    key: "11",
    icon: <FaBuildingUser />,
    label: <CustomLink to="/company">{"نقش حقوقی"}</CustomLink>,
  },
  {
    key: "12",
    icon: <FaRegCalendarAlt />,
    label: <CustomLink to="/scheduler">{"تقویم"}</CustomLink>,
  },
  {
    key: "13",
    icon: <GrTest />,
    label: <CustomLink to="/laboratory">{"آزمایشگاه ها"}</CustomLink>,
  },
  {
    key: "14",
    icon: <HiOutlineInboxArrowDown />,
    label: "کارپوشه",
    children: [
      {
        key: "14-1",
        label: <CustomLink to="/cartable">{"پیام های شخصی"}</CustomLink>,
      },
      {
        key: "14-2",
        label: (
          <CustomLink to="/laboratoaries-cartable">{"آزمایشگاه ها"}</CustomLink>
        ),
      },
    ],
  },

  {
    key: "15",
    icon: <ProfileOutlined />,
    label: (
        <CustomLink to="/Laboratory-profile">{"نمایه آزمایشگاه"}</CustomLink>
    ),
  },
];
const adminItems: MenuItem[] = [
  {
    key: "1",
    icon: <MdDashboard />,
    label: <CustomLink to="/user-role">{"مدیریت کاربران"}</CustomLink>,
  },
];

const bottomMenuItems = [
  // {
  //   key: "11",
  //   icon: <AiOutlineUser />,
  //   label: <CustomLink to="/user-profile">{"نمایه کاربری"}</CustomLink>,
  // },
  {
    key: "12",
    icon: <HiOutlineInboxArrowDown />,
    label: <CustomLink to="/cartable">{"کارپوشه"}</CustomLink>,
  },

  // {
  //   key: "13",
  //   icon: <TbMessage2Exclamation />,
  //   label: "ثبت تیکت",
  // },
];

export { items, bottomMenuItems, adminItems };
